import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ActivityRecorderService, RecordingState, RecordingStats } from '../../../services/activity-recorder.service';
import { Subscription } from 'rxjs';
import { ActivityEditComponent } from '../activity-edit/activity-edit.component';
import { AnimalService } from '../../../services/animal.service';

@Component({
  selector: 'app-recorder-widget',
  standalone: true,
  templateUrl: './recorder-widget.component.html',
  styleUrls: ['./recorder-widget.component.scss'],
  imports: [CommonModule, IonicModule, TranslateModule]
})
export class RecorderWidgetComponent implements OnInit, OnDestroy {
  state: RecordingState = 'idle';
  stats: RecordingStats = { durationMs: 0, distanceKm: 0, currentSpeedKph: 0, averageSpeedKph: 0, elevationGainMeters: 0 };
  error: string | null = null;
  minimize = false;
  
  private subs = new Subscription();

  constructor(
    private recorder: ActivityRecorderService,
    private modalCtrl: ModalController,
    private animalService: AnimalService
  ) {}

  ngOnInit() {
    this.subs.add(this.recorder.state$.subscribe(s => this.state = s));
    this.subs.add(this.recorder.stats$.subscribe(s => this.stats = s));
    this.subs.add(this.recorder.error$.subscribe(e => this.error = e));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  togglePause() {
    if (this.state === 'ready') {
      this.recorder.start();
    } else if (this.state === 'recording') {
      this.recorder.pause();
    } else if (this.state === 'paused') {
      this.recorder.resume();
    }
  }

  async stopRecording() {
    const result = await this.recorder.stop();
    this.openActivityEdit(result);
  }

  formatDuration(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  async openActivityEdit(result: { stats: RecordingStats, gpx: string, animalIds: number[] }) {
    const allAnimals = this.animalService.animals || [];
    const selectedAnimals = result.animalIds.map(id => allAnimals.find((a: any) => a.id === id)).filter(a => !!a) as any[];
    
    const props = {
        // Pre-fill data
        recordedData: {
          distance: result.stats.distanceKm,
          duration: result.stats.durationMs / 60000, // minutes
          gpxContent: result.gpx,
          elevationGain: result.stats.elevationGainMeters
        },
        showSaveButton: true,
        allAnimals: allAnimals,
        animal: selectedAnimals.length > 0 ? selectedAnimals[0] : null
    };

    console.log('RecorderWidgetComponent: Opening ActivityEdit with props:', props);
    const modal = await this.modalCtrl.create({
      component: ActivityEditComponent,
      componentProps: props
    });
    
    modal.onDidDismiss().then(() => {
        // Maybe refresh activities?
    });

    return await modal.present();
  }
}
